import { actionCreator } from '../action-created'
import { LOAD_TRUE, LOAD_FALSE } from './key'
export const preload_true = () => actionCreator(LOAD_TRUE)
export const preload_false = () => actionCreator(LOAD_FALSE)